import {
  FaArrowRight,
  FaFacebookF,
  FaInstagram,
  FaTwitter,
} from "react-icons/fa6";
import NuprexLogoFooter from "./NuprexLogoFooter";
import Marquee from "react-fast-marquee";
import TwentyFourHours from "./TwentyFourHours";
import { Link } from "react-scroll"; // Link from react-scroll
import { Link as RouterLink } from "react-router-dom"; // Alias Link from react-router-dom to RouterLink
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { UAParser } from "ua-parser-js";

const Footer = ({ scrollToSection }) => {
  const [email, setEmail] = useState("");

  const handleSubmit = async () => {
    if (!email) {
      alert("Please enter a valid email address.");
      return;
    }

    try {
      axios.post("https://sheetdb.io/api/v1/62p5d7v4c5zmq", {
        data: {
          email: email,
        },
      });

      // Handle success response
      // console.log('Email sent successfully:', response.data);
      // Swal.fire('Success!', 'Your email has been submitted.', 'success');
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        },
      });
      Toast.fire({
        icon: "success",
        title: "Email submitted successfully!",
      });

      // Clear the email input after submission
      setEmail("");
    } catch (error) {
      // Handle error response
      console.error("Error sending email:", error);
      // Swal.fire("Error!", "There was an issue submitting your email.", "error");
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        },
      });
      Toast.fire({
        icon: "Error!",
        title: "Error submitting your email!",
      });
    }
  };

  const [deviceType, setDeviceType] = useState("");
   const [os, setOs] = useState("");
 
   useEffect(() => {
     const parser = new UAParser();
     const detectedDevice = parser.getDevice().type || "desktop"; // Default to 'desktop' if no device type is detected
     const detectedOs = parser.getOS().name;
 
     setDeviceType(detectedDevice);
     setOs(detectedOs);
   }, []);
 
   const handleGetStarted = () => {
     if (os === "Android") {
       window.location.href =
         "https://play.google.com/store/apps/details?id=com.nuprex.nuprexCustomerApplication&hl=en";
     } else if (os === "iOS") {
       window.location.href =
         "https://apps.apple.com/ng/app/nuprex-delivery-run-errands/id6738646035";
     } else {
      Swal.fire({
        title: "Device Not Supported",
        text: `The Nuprex app is optimized for mobile devices. You are using a ${deviceType}.`,
        icon: "error",
        confirmButtonText: "Okay",
        confirmButtonColor: "#0041a9",
      });
     }
   };

  return (
    <footer>
      <div className="position-relative footer-bg px-5">
        <TwentyFourHours />
      </div>
      <div className="container-fluid  footer-bg ">
        <div className="container" style={{ paddingTop: "7em" }}>
          <div className="row">
            <div className="col-md-2">
              <p className="text-white">Company</p>
              <div
                style={{
                  opacity: ".75",
                  color: "#fff",
                  fontSize: "13px",
                  width: "250px",
                }}
              >
                <small
                  onClick={() => scrollToSection("about")}
                  className="cursor-pointer cursor-pointer"
                >
                  About us
                </small>

                <br />
                <small
                  onClick={() => scrollToSection("offer")}
                  className="cursor-pointer cursor-pointer"
                >
                  What we offer
                </small>
                <br />
               <small
  onClick={() => {
    Swal.fire({
      title: "Join Our Team",
      html: `At Nuprex, we are always excited to welcome talented and qualified candidates to join our growing team. If you see a position that matches your skills on our website, social media platforms or job boards, we encourage you to apply. Kindly send your resume to <a href="mailto:careers@nuprex.com.ng">careers@nuprex.com.ng</a> and take the first step toward becoming part of our dynamic workforce.`,
      icon: "question",
      confirmButtonColor: "#0041a9",
    });
  }}
  className="cursor-pointer"
>
  Careers
</small>
                <br />
               
                  <small onClick={handleGetStarted} className="cursor-pointer cursor" >
                    Download our Applications
                  </small>
                

                <br />
                <RouterLink to="/terms" className="color-white white">
                  <small className="cursor-pointer">Terms of Service</small>
                </RouterLink>
                <br />
                <RouterLink to="/privacy-policy" className="color-white white">
                  <small className="cursor-pointer">Privacy Policy</small>
                </RouterLink>
                <br />
              </div>
            </div>
            <div className="col-md-3">
              <p className="text-white mb-3">Address</p>
              <div
                style={{
                  opacity: ".75",
                  color: "#fff",
                  fontSize: "13px",
                  width: "250px",
                }}
              >
                <small>
                  Third floor Unit 8/9, building 1, View Point Plaza Ajah, NEPA
                  road, Ajah, Lagos
                </small>
                <br />

                <small
                  className=""
                  style={{ position: "relative", top: "0.3em" }}
                >
                  Shop 13, Phase 2, Hajiya Fatima POWA shopping Complex, Oba
                  Akinjobi Way GRA Ikeja
                </small>
              </div>
            </div>
            <div className="col-md-3">
              <p className="text-white mb-3">Contact</p>
              <div style={{ opacity: ".75", color: "#fff", fontSize: "13px" }}>
                <small>
                  <a href="tel:+2347000687739" style={{ color: "#fff" }}>
                    +234-7000-NUPREX
                  </a>
                </small>{" "}
                <br />
                <small>
                  <a href="tel:02018880243" style={{ color: "#fff" }}>
                    02018880243
                  </a>
                </small>{" "}
                <br />
                <small>
                  <a href="mailto:info@nuprex.com.ng" style={{ color: "#fff" }}>
                    info@nuprex.com.ng
                  </a>
                </small>
                <br />
                <small className="mt-3">
                  <a
                    href="mailto:customercare@nuprex.com.ng"
                    style={{ color: "#fff" }}
                  >
                    customercare@nuprex.com.ng
                  </a>
                </small>
              </div>
            </div>
            <div
              className="col-md-4"
              style={{
                backgroundColor: "rgba(255,255,255, .1)",
                width: "300px",
                height: "250px",
              }}
            >
              <p className="text-white mt-2">Subscribe</p>
              <div>
                <div className="d-flex">
                  <input
                    type="email"
                    placeholder="Email Address"
                    className="rounded-start border-0 p-2"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <button
                    className="rounded-end footer-bg border-0 p-2"
                    onClick={handleSubmit}
                  >
                    <FaArrowRight className="text-white" />
                  </button>
                </div>

                <p
                  className="text-justify mt-2"
                  style={{ fontSize: "12px", color: "#fff", opacity: ".6" }}
                >
                  Hello, we are Nuprex. Our goal is to translate the positive
                  effects from moving what matters to our customers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bg container-fluid">
        <Marquee autoFill={true}>
          <p className="weMoveGradient">
            WE MOVE WHAT MATTERS WE MOVE WHAT MATTERS
          </p>
          <p className="weMoveGradient">
            WE MOVE WHAT MATTERS WE MOVE WHAT MATTERS
          </p>
        </Marquee>
        <div className="row justify-content-center align-items-center">
          <div className="col-md-4 text-center">
            {" "}
            <NuprexLogoFooter size={"100"} />
          </div>
          <div className="col-md-4 text-center d-flex gap-3 text-white">
            <RouterLink
              to="/terms"
              style={{ color: "white", textDecoration: "none" }}
            >
              <p className="cursor-pointer">Terms</p>
            </RouterLink>
            <RouterLink
              to="/privacy-policy"
              style={{ color: "white", textDecoration: "none" }}
            >
              {" "}
              <p className="cursor-pointer">Privacy</p>
            </RouterLink>
            <Link style={{ color: "white", textDecoration: "none" }}>
              <p className="cursor-pointer">Cookies</p>
            </Link>
          </div>
          <div className="col-md-4 text-center d-flex gap-3">
            <Link to="https://www.facebook.com/share/FvHm56fL5Zeet2St/?mibextid=wwXIfr">
              <FaFacebookF
                className="footer-text bg-white rounded-circle p-3 cursor-pointer"
                size={50}
              />
            </Link>{" "}
            <Link to="https://www.instagram.com/nuprex_official/profilecard/?igsh=MXMyMnJ0c2d3cmg0bg== ">
              <FaInstagram
                className="footer-text bg-white rounded-circle p-3 cursor-pointer"
                size={50}
              />
            </Link>{" "}
            <Link to="https://x.com/Nuprexltd">
              <FaTwitter
                className="footer-text bg-white rounded-circle p-3 cursor-pointer"
                size={50}
              />
            </Link>
          </div>
        </div>
      </div>
      <div>
        <p style={{ fontSize: "12px" }} className="text-center py-4 m-0">
          © 2024 Nuprex. All rights reserved.
        </p>
      </div>
    </footer>
  );
};
export default Footer;
